// Generated by ts-to-zod
import {z} from "zod";
import {
	mantineCssStyleRecordSchema,
	mantineStylesApiSchema,
} from "./primitives.zod";
import {mantineSpacingSchema} from "./spacing.zod";

export const mantinePaperPropsSchema = z.strictObject({
	withBorder: z.boolean().optional(),
	shadow: z.string().optional(),
	p: mantineSpacingSchema.optional(),
	px: mantineSpacingSchema.optional(),
	py: mantineSpacingSchema.optional(),
	style: mantineCssStyleRecordSchema.optional(),
	styles: mantineStylesApiSchema.optional(),
});
